module.exports = __webpack_public_path__ + "img/screen-img-01.29994f5b.jpeg";